module.exports = __webpack_public_path__ + "static/media/opex.84d534a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/opex.svg
// module id = 390
// module chunks = 7